import { FC } from 'react';

import Table from 'modules/_shared/Table';

import ShareTitleTableHeader from './ShareTitleTableHeader';
import ShareTitleTableBody from './ShareTitleTableBody';

const ShareTitleTable: FC = () => {
  const tableContent = (
    <>
      <ShareTitleTableHeader />
      <ShareTitleTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default ShareTitleTable;
